<template>
  <div class="content">
    <h2 class="m-n">だれでも掲示板</h2>

    <div class="row m-t-md">
      <div class="hpanel">
        <div class="panel-body">
          <div class="text-left">
            SaleMonsterのセラーさま同士が自由に意見交換や情報共有を行うためのオンライン掲示板です。
          </div>
          <div class="text-left">
            物販関連のことでしたら、SaleMonster以外のトピックでもOK！
          </div>
          <div class="text-left">
            コメントをしたり、いいね！することもできます。
          </div>
          <div class="text-left">
            SaleMonsterに対するリクエストも受け付けております♪
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <button
          class="btn btn-info btn-m--left w-100"
          data-toggle="modal"
          data-target="#postRequest"
          @click="openModalRequest"
          ref="postRequest"
        >
          投稿
        </button>
        <button class="btn btn-guide btn-m--left w-120 mr-l-5" @click="openModalGuideLine">
          ガイドライン
        </button>
      </div>
    </div>

    <div class="row custom_table">
      <base-table
        :url="'requests'"
        :method="'get'"
        :columns="$options.requestColumns"
        ref="requestTable"
        @clickRow="openRequestDetail"
      >
        <template slot="createdAt" slot-scope="props">
          <span>{{ props.rowData.createdAt }}</span>
        </template>
        <template slot="likesCount" slot-scope="props">
          <span class="like-count">{{ formatAmount(props.rowData.likesCount) }}</span>
        </template>
        <template slot="title" slot-scope="props">
          <span class="title-color">{{ props.rowData.title }}</span>
          <div v-if="props.rowData.commentsCount > 0" class="comment">
            <img src="/static/dists/img/ic_comment.png" />
            <span class="comment_count">{{ formatAmount(props.rowData.commentsCount) }} 件のコメント</span>
          </div>
        </template>
      </base-table>
    </div>
    <post-request v-if="isShowRequest"  @close="closeModalRequest"></post-request>
    <guide-line v-if="openModalGuide" @close="closeModalGuideLine"></guide-line>
  </div>
</template>
<script>
import BaseTable from '@/components/BaseTable'
import PostRequest from './PostRequest.vue'
import GuideLine from './GuideLine'
import Util from '@/common/utility'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  components: {
    BaseTable,
    PostRequest,
    GuideLine
  },
  data () {
    return {
      loader: null,
      isShowRequest: false,
      openModalGuide: false
    }
  },
  requestColumns: [
    {
      title: '登録日',
      name: 'createdAt',
      customCell: true,
      cellClass: 'text-center hover_cell',
      headerClass: 'col-sm-2',
      width: '150px'
    },
    {
      title: 'いいね',
      name: 'likesCount',
      customCell: true,
      cellClass: 'text-center hover_cell',
      headerClass: 'col-sm-2',
      width: '100px'
    },
    {
      title: 'タイトル',
      name: 'title',
      customCell: true,
      cellClass: 'text-left hover_cell',
      sortable: false,
      headerClass: 'col-sm-9 th-title'
    }
  ],
  mounted () {
    this.$events.listen('done', () => {
      this.loader && this.loader.hide()
    })
    let logParams = {
      name: eventCode.requests.show,
      properties: {}
    }
    EventService.postTrackLog(logParams)
  },
  created () {},
  methods: {
    formatAmount (value) {
      return value === null || typeof value === 'undefined' || value === 0
        ? ''
        : `${Util.formatMoney(value)}`
    },
    openModalRequest () {
      this.isShowRequest = true
    },
    closeModalRequest () {
      $('#postRequest').modal('hide')
      this.$refs.requestTable.reload(false, false, false, false)
      this.isShowRequest = false
    },
    openRequestDetail (item) {
      this.$router.push({
        name: 'RequestComment',
        params: { id: item.id }
      })
    },
    openModalGuideLine () {
      this.openModalGuide = true
    },
    closeModalGuideLine () {
      $('#guideLine').modal('hide')
      this.openModalGuide = false
    }
  },
  beforeDestroy () {
    this.$events.remove('done')
    this.loader && this.loader.hide()
  }
}
</script>

<style scoped>
.btn-guide {
  color: #000;
  background-color: #d9d9d9;
}
.comment {
  background-color: rgba(242, 242, 242);
  padding: 5px 25px 5px 5px;
  border-radius: 5px;
  width: fit-content;
}

.comment_count {
  font-size: 10px;
}

.like-count {
  font-size: 20px;
}

.title-color {
  font-size: 20px;
  font-weight: 600;
  color: #008cc6;
}

@media (max-width: 768px) {
  .like-count {
    font-size: 14px;
  }
  .title-color {
    font-size: 14px;
  }
}
@media (max-width: 425px) {
  .custom_table /deep/ .table-wrapper {
    overflow-x: auto;
  }
  .custom_table /deep/ .table-wrapper .table {
    width: max-content;
    max-width: max-content;
  }
  .custom_table /deep/ .table-wrapper .table .th-title {
    width: 350px;
  }
  .custom_table /deep/ .table-wrapper .table .title-color {
    display: block;
    width: 350px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/request/Request.vue